export class RiskManagementParameters {
  public initial_capital: number;
  public aggressiveness: string;
  public protection_horizon: number;
  public rebalancing_frequency: string;
  public target_type: string;
  public protection_level: number;
  public risk_free_rate: number;
  public simulation_pivot: string;
  public metrics_pivot: string;

  // initialize from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.initial_capital       = data.initial_capital;
    this.aggressiveness        = data.aggressiveness;
    this.protection_horizon    = data.protection_horizon;
    this.rebalancing_frequency = data.rebalancing_frequency;
    this.target_type           = data.target_type;
    this.protection_level      = data.protection_level;
    this.risk_free_rate        = data.risk_free_rate;
    this.simulation_pivot      = data.simulation_pivot;
    this.metrics_pivot         = data.metrics_pivot;
  }

}